if (!customElements.get('fit-text')) {
  class FitText extends HTMLElement {
    constructor() {
      super();
      this.baseFontSize = 200;
      this.resize = this.resize.bind(this);
    }

    connectedCallback() {
      this.style.display = 'inline-block';
      this.style.whiteSpace = 'nowrap';

      this.ro = new ResizeObserver(() => this.resize());
      this.ro.observe(this.parentElement);

      if (document.fonts) {
        document.fonts.ready.then(() => this.resize());
      }

      this.resize();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }

    resize() {
      const container = this.parentElement;
      if (!container) return;

      const containerWidth = container.clientWidth;
      if (containerWidth === 0) return;

      this.style.fontSize = this.baseFontSize + 'px';
      const textWidth = this.scrollWidth;
      if (textWidth === 0) return;

      const scale = containerWidth / textWidth;
      this.style.fontSize = (this.baseFontSize * scale) + 'px';
    }
  }

  customElements.define('fit-text', FitText);
}
